import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import './style.scss'

export default class ControlButton extends Component {
    static propTypes = {
        active: PropTypes.bool.isRequired,
        onClickHandler: PropTypes.func,
        type: PropTypes.oneOf(['left', 'right']).isRequired,
    }

    static defaultProps = {
        onClickHandler: () => {},
    }

    onClickHandler = () => {
        const { active, type, onClickHandler } = this.props

        if (active) onClickHandler(type)
    }

    render() {
        const { active, type } = this.props

        return (
            <div
                className={cx('buttons-array-control-button', active && 'active', `type-${type}`)}
                onClick={this.onClickHandler}
            />
        )
    }
}
